import { UI, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { CustomerPrivatePensionContractedNormalized } from '../../../../../../../../store/customerDetail/privatePension/types';
import {
  ItemDataInfo,
  getPrivatePensionCardResumedInfos,
} from '../../../PrivatePensionCard/constants';
import { PrivatePensionCardItem } from '../../../PrivatePensionCardItem';

export interface PrivatePensionInfoProps {
  privatePensionContracted: CustomerPrivatePensionContractedNormalized;
}

export const PrivatePensionInfo: React.FC<PrivatePensionInfoProps> = ({
  privatePensionContracted,
}) => {
  const numColumns = useBreakpointValue({ base: 1, sm: 3, md: 2, lg: 3 });

  const renderInfo = (item: ItemDataInfo) => {
    return <PrivatePensionCardItem label={item.label} value={item.value} numColumns={numColumns} />;
  };

  return (
    <VStack
      px={Spacing['inline.xxs']}
      py={Spacing['stack.xxxs']}
      space={Spacing['stack.xxs']}
      borderRadius={BoxBorder.heavy}
      bgColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.5)}>
      <UI.Text variant="semibold" color="neutral.black">
        Informações do certificado
      </UI.Text>
      <FlatList
        key={`private-pension-card-flatlist-${numColumns}`}
        data={getPrivatePensionCardResumedInfos(privatePensionContracted)}
        showsVerticalScrollIndicator={false}
        renderItem={({ item }) => renderInfo(item)}
        ItemSeparatorComponent={() => <Box h="16px" />}
        numColumns={numColumns}
      />
    </VStack>
  );
};
